import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../components/footer/footer.component';
import { HeaderComponent } from '../components/header/header.component';

@Component({
  templateUrl: './student-shell.component.html',
  styleUrls: ['./student-shell.component.scss'],
  standalone: true,
  imports: [RouterOutlet, FooterComponent, HeaderComponent],
})
export class StudentShellComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
